const SELECTOR = {
  TRIGGER: '.js-country-switcher-trigger',
  LINK: '.js-country-switcher-drawer-link',
  SEARCH_INPUT: '.js-country-switcher-drawer-search-input',
  POPULAR_LIST: '.js-country-switcher-drawer-popular-list',
  SEPARATOR: '.js-country-switcher-drawer-separator',
  ALL_COUNTRIES_LIST: '.js-country-switcher-drawer-all-countries',
};

const TEMPLATE_ID = 'el-country-switcher-drawer-template';

elabs.CountrySwitcherDrawer = class {
  constructor() {
    if (elabs.CountrySwitcherDrawer.instance) {
      return elabs.CountrySwitcherDrawer.instance;
    }
    elabs.CountrySwitcherDrawer.instance = this;

    this.triggerBtn = document.querySelector(SELECTOR.TRIGGER);
    if (this.triggerBtn) {
      this.htmlContent = null;
      this.init();
    }
  }

  init() {
    this.triggerBtn.addEventListener('click', (event) => {
      event.preventDefault();
      this.openOverlay();
    });
  }

  openOverlay = async () => {
    if (!this.htmlContent) {
      try {
        const response = await fetch('/pages/contact?view=ajax-country-switcher-content');
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        this.htmlContent = await response.text();
        this.createTemplate();
      } catch (error) {
        console.error('CountrySwitcherDrawer: Failed to fetch content.', error);
        return;
      }
    }

    elabs.overlayMenuService.showMenu({ templateId: TEMPLATE_ID }, 'left');
    setTimeout(this.addEventListeners, 0);
  };

  createTemplate = () => {
    if (document.getElementById(TEMPLATE_ID)) {
      return;
    }
    const template = document.createElement('template');
    template.id = TEMPLATE_ID;
    template.innerHTML = this.htmlContent;
    document.body.appendChild(template);
  };

  addEventListeners = () => {
    const overlayContent = document.querySelector('.el-overlay-menu__body');
    if (!overlayContent) {
      return;
    }

    const searchInput = overlayContent.querySelector(SELECTOR.SEARCH_INPUT);
    const popularList = overlayContent.querySelector(SELECTOR.POPULAR_LIST);
    const separator = overlayContent.querySelector(SELECTOR.SEPARATOR);
    const allCountryItems = overlayContent.querySelectorAll(
      `${SELECTOR.ALL_COUNTRIES_LIST} .el-country-switcher-drawer__item`,
    );

    searchInput?.addEventListener('input', (e) => {
      const val = e.target.value.toLowerCase().trim();
      const targetSelector = `.js-country-switcher-drawer-all-countries [data-name^="${val}"]`;

      popularList.style.display = val.length > 0 ? 'none' : 'flex';
      separator.style.display = val.length > 0 ? 'none' : 'block';

      allCountryItems.forEach((item) => (item.style.display = 'none'));
      if (val.length > 0) {
        overlayContent.querySelectorAll(targetSelector).forEach((el) => (el.style.display = 'block'));
      } else {
        allCountryItems.forEach((item) => (item.style.display = 'block'));
      }
    });

    overlayContent.addEventListener('click', (event) => {
      const link = event.target.closest(SELECTOR.LINK);
      if (!link) {
        return;
      }

      event.preventDefault();
      const form = link.closest('form');
      if (form) {
        const countryInput = form.querySelector('[name="country_code"]');
        if (countryInput) {
          countryInput.value = link.dataset.value;
        }

        let returnToInput = form.querySelector('input[name="return_to"]');
        if (!returnToInput) {
          returnToInput = document.createElement('input');
          returnToInput.type = 'hidden';
          returnToInput.name = 'return_to';
          form.appendChild(returnToInput);
        }
        returnToInput.value = window.location.pathname + window.location.search;
        form.submit();
      }
    });
  };
};

elabs.onJavascriptReady(() => {
  elabs.countrySwitcherDrawer = new elabs.CountrySwitcherDrawer();
});
